export default __webpack_public_path__ + "static/assets/7360cbb2834cc7fb575404501730bdb5.png";